import React from 'react';
import Parse from 'parse';
import { GetQuestionsConfiguration } from './Configuration/QuestionConfiguration';
import TinyLoader from '../../Components/Loader/TinyLoader';
import {Admin} from '../../../configurations/Admin';
import TwoOptionsQuestion from './../../Components/Presentation/TwoOptionsQuestion/TwoOptionsQuestion';
import Switch from "react-switch";
import './PlanningPreference.css';
import orthogram from './../../../assets/img/ortogram.svg'

class PlanningPreference extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patient: props.patient,
      loading:false,
      isError:false,
      correctMolar:false, 
      correctCanine:false, 
      correctCross:false, 
      correctVerticalOverbite:false, 
      correctHorizontalOverbite:false,
      treatUpperArcade:false,
      treatLowerArcade:false,
      treatBothArcades:false,
      isAlignmentByExpansion:false,
      isAlignmentByProinclination:false,
      isAlignmentByWear:false,
      isAlignmentByExtraction:false,
      piecesToExtract:"",
      useAttachments:false,
      attachmentsRestrictions:"",
      additionalConsiderations:"",
      alignmentByExtractionError:"",
      useAttachmentsError:""
    }
  }

  componentDidMount = () => {
    this.updateQuestionsWithPatientData(this.props.patient);
    this.setState({patient: this.props.patient});
  }


  countErrorsAndValidateFields = () => {
    const { 
      isAlignmentByExtraction, 
      piecesToExtract,
      useAttachments,
      attachmentsRestrictions,
    } = this.state;

    let errors = 0;
    if(isAlignmentByExtraction){
      if(piecesToExtract === ""){
        errors = errors + 1;
        this.setState({alignmentByExtractionError:"Debes especificar el número de las piezas a retirar"});
      }
    }

    return errors;
  }

  onSave = async () => {
    this.setState({loading:true, isError:false, alignmentByExtractionError:"", useAttachmentsError:""});

    let currentUser = Parse.User.current();
    if(currentUser.get("username") === Admin.user_admin){
      this.setState({isError:true, loading:false});
      return;
    }
    
    const { 
      correctMolar, correctCanine, correctCross, 
      correctVerticalOverbite, correctHorizontalOverbite, treatUpperArcade,
      treatLowerArcade, treatBothArcades, isAlignmentByExpansion,
      isAlignmentByProinclination,
      isAlignmentByWear,
      isAlignmentByExtraction, 
      piecesToExtract,
      useAttachments,
      attachmentsRestrictions,
      additionalConsiderations,
    } = this.state;
    

    let errorsCounter = await this.countErrorsAndValidateFields();
    
    if(errorsCounter > 0){
      this.setState({ isError:true, loading:false });
      return;
    }

    this.setState({isError:false});

    const Patient = Parse.Object.extend('Patient');
    const query = new Parse.Query(Patient);
    const {patient} = this.props;

    let patientFounded = await query.get(patient.id);
    patientFounded.set("correctMolar", correctMolar);
    patientFounded.set("correctCanine", correctCanine);
    patientFounded.set("correctCross", correctCross);
    patientFounded.set("correctVerticalOverbite", correctVerticalOverbite); 
    patientFounded.set("correctHorizontalOverbite", correctHorizontalOverbite); 
    patientFounded.set("treatUpperArcade", treatUpperArcade);
    patientFounded.set("treatLowerArcade", treatLowerArcade);
    patientFounded.set("isAlignmentByExpansion", isAlignmentByExpansion);
    patientFounded.set("isAlignmentByProinclination", isAlignmentByProinclination);
    patientFounded.set("isAlignmentByWear", isAlignmentByWear);
    patientFounded.set("isAlignmentByExtraction", isAlignmentByExtraction);
    patientFounded.set("piecesToExtract", piecesToExtract);
    patientFounded.set("useAttachments", useAttachments);
    patientFounded.set("attachmentsRestrictions", attachmentsRestrictions);
    patientFounded.set("additionalConsiderations", additionalConsiderations);

    await patientFounded.save();
    this.setState({loading:false});
  }

  updateQuestionsWithPatientData = (patient) => {
    if(patient === null || patient.id === 0){
      return;
    }
    
    this.setState({
      correctMolar: patient.get("correctMolar"),
      correctCanine: patient.get("correctCanine"),
      correctCross: patient.get("correctCross"),
      correctVerticalOverbite: patient.get("correctVerticalOverbite"),
      correctHorizontalOverbite: patient.get("correctHorizontalOverbite"),
      treatUpperArcade: patient.get("treatUpperArcade"),
      treatLowerArcade: patient.get("treatLowerArcade"),
      treatBothArcades: patient.get("treatUpperArcade") && patient.get("treatLowerArcade")? true: false,
      isAlignmentByExpansion: patient.get("isAlignmentByExpansion"),
      isAlignmentByProinclination: patient.get("isAlignmentByProinclination"),
      isAlignmentByWear: patient.get("isAlignmentByWear"),
      isAlignmentByExtraction: patient.get("isAlignmentByExtraction"),
      piecesToExtract: patient.get("piecesToExtract"),
      useAttachments: patient.get("useAttachments"),
      attachmentsRestrictions: patient.get("attachmentsRestrictions"),
      additionalConsiderations: patient.get("additionalConsiderations"),
    });
  }

  handleSwitch = (checked, name) => {
    if(name === "correctMolar"){ this.setState({correctMolar:checked}); return; }
    if(name === "correctCanine"){ this.setState({correctCanine:checked}); return; }
    if(name === "correctCross"){ this.setState({correctCross:checked}); return; }
    if(name === "correctVerticalOverbite"){ this.setState({correctVerticalOverbite:checked}); return; }
    if(name === "correctHorizontalOverbite"){ this.setState({correctHorizontalOverbite:checked}); return; }
  }

  handleArcadeTreatment(changed){
    let {treatUpperArcade, treatLowerArcade, treatBothArcades} = this.state;
    this.setState({treatBothArcades:false});
    if(changed === "treatUpperArcade"){
      treatUpperArcade = !treatUpperArcade;
      this.setState({treatUpperArcade:treatUpperArcade});
      if(treatUpperArcade && treatLowerArcade){
        this.setState({treatBothArcades:true});
      }
      return;
    }

    if(changed === "treatLowerArcade"){
      treatLowerArcade = !treatLowerArcade;
      this.setState({treatLowerArcade:treatLowerArcade});
      if(treatUpperArcade && treatLowerArcade){
        this.setState({treatBothArcades:true});
      }
      return;
    }

    if(changed === "treatBothArcades"){
      treatBothArcades = !treatBothArcades;
      this.setState({treatBothArcades:treatBothArcades});
      if(treatBothArcades){
        this.setState({treatUpperArcade:true, treatLowerArcade:true});
      }else{
        this.setState({treatUpperArcade:false, treatLowerArcade:false});
      }
      return;
    }
  }

  render() {
    const {patient} = this.state;
    if(patient === null){
      return <p>Usuario inválido</p>
    }else{
      if(!patient){
        return <p>cargando...</p>
      }
    }

    const loading = this.state.loading ? <TinyLoader/> : null;

    let errorOnForm = null;
    if(this.state.isError){
      errorOnForm = <p className="error text-center">Existen algunos errores en el formulario</p>
    }

    const { correctMolar, correctCanine, correctCross, 
      correctVerticalOverbite, correctHorizontalOverbite, treatUpperArcade,
      treatLowerArcade, treatBothArcades,
      isAlignmentByExpansion,
      isAlignmentByProinclination,
      isAlignmentByWear,
      isAlignmentByExtraction,
      piecesToExtract,
      useAttachments,
      attachmentsRestrictions,
      additionalConsiderations,
      alignmentByExtractionError,
      useAttachmentsError
    } = this.state;
    
    return(
      <div>
        <div className="vertical-separator-24px"></div> 

        <h3>Órden de laboratorio digital</h3>
        
        <div className="vertical-separator-8px"></div> 

        <div className="row">
          <div className="col-md-6">
            <TwoOptionsQuestion
              name="correctMolar"
              title="Clase Molar:"
              trueLabel="Mantener"
              falseLabel="Corregir"
              value={correctMolar}
              handleChange={this.handleSwitch}
            />
          </div>
          <div className="col-md-6">
            <TwoOptionsQuestion
              name="correctCanine"
              title="Clase Canina:"
              trueLabel="Mantener"
              falseLabel="Corregir"
              value={correctCanine}
              handleChange={this.handleSwitch}
            />
          </div>
          <div className="col-md-6">
            <TwoOptionsQuestion
              name="correctCross"
              title="Transversal"
              trueLabel="Mantener"
              falseLabel="Corregir"
              value={correctCross}
              handleChange={this.handleSwitch}
            />
          </div>
          <div className="col-md-6">
            <TwoOptionsQuestion
              name="correctVerticalOverbite"
              title="Sobremordida Vertical:"
              trueLabel="Mantener"
              falseLabel="Corregir"
              value={correctVerticalOverbite}
              handleChange={this.handleSwitch}
            />
          </div>
          <div className="col-md-6">
            <TwoOptionsQuestion
              name="correctHorizontalOverbite"
              title="Sobremordida Horizontal:"
              trueLabel="Mantener"
              falseLabel="Corregir"
              value={correctHorizontalOverbite}
              handleChange={this.handleSwitch}
            />
          </div>
        </div>

        <div className="vertical-separator-32px"></div> 

        <div className="row">
          <div className="col-md-3 col-sm-3">
            <label>Arcada a tratar</label>
          </div>
          <div className="col-md-3 col-sm-3 col-xs-12 ">
            <input type="checkbox"
              id="treatUpperArcade"
              checked={treatUpperArcade}
              onChange={()=> this.handleArcadeTreatment("treatUpperArcade")} />
            <label htmlFor="treatUpperArcade" className="option-answer">Superior</label>
          </div>
          <div className="col-md-3 col-sm-3 col-xs-12">
            <input type="checkbox"
              id="treatLowerArcade"
              checked={treatLowerArcade}
              onChange={()=> this.handleArcadeTreatment("treatLowerArcade")} />
            <label htmlFor="treatLowerArcade" className="option-answer">Inferior</label>
          </div>
          <div className="col-md-3 col-sm-3 col-xs-12">
            <input type="checkbox"
              id="treatBothArcades"
              checked={treatBothArcades}
              onChange={()=> this.handleArcadeTreatment("treatBothArcades")} />
            <label htmlFor="treatBothArcades" className="option-answer">Ambas</label>
          </div>
        </div>
      
        <div className="vertical-separator-32px"></div> 

        <div className="row">
          <div className="col-md-12">
            <label>Alinear arcadas mediante (seleccionar las que apliquen)</label>
          </div>
          <div className="col-md-12 col-xs-12 text-left arcada-questions">
            <div className="row">
              <div className="col-md-3 col-xs-12 aling-arcada">
                <input 
                  type="checkbox" 
                  id="isAlignmentByExpansion"
                  checked={isAlignmentByExpansion}
                  onChange={()=> this.setState({isAlignmentByExpansion:!isAlignmentByExpansion})}  
                />
                <label className="option-answer aling-arcada-option" htmlFor="isAlignmentByExpansion">Expansión lateral</label>
              </div>
              <div className="col-md-3 col-xs-12 aling-arcada">
                <input 
                  type="checkbox" 
                  id="isAlignmentByProinclination"
                  checked={isAlignmentByProinclination}
                  onChange={()=> this.setState({isAlignmentByProinclination:!isAlignmentByProinclination})}
                />
                <label className="option-answer aling-arcada-option" htmlFor="isAlignmentByProinclination">Proinclinación</label>
              </div>
              <div className="col-md-3 col-xs-12 aling-arcada">
                <input
                  type="checkbox" 
                  id="isAlignmentByWear"
                  checked={isAlignmentByWear}
                  onChange={()=> this.setState({isAlignmentByWear:!isAlignmentByWear})}
                />
                <label className="option-answer aling-arcada-option" htmlFor="isAlignmentByWear">Desgaste</label>
              </div>
              <div className="col-md-3 col-xs-12 aling-arcada">
                <input 
                  type="checkbox" 
                  id="isAlignmentByExtraction"
                  checked={isAlignmentByExtraction}
                  onChange={()=> {
                    this.setState({isAlignmentByExtraction:!isAlignmentByExtraction});
                    if(!isAlignmentByExtraction === false){
                      this.setState({piecesToExtract:""});
                    }
                  }}
                />
                <label className="option-answer aling-arcada-option" htmlFor="isAlignmentByExtraction">Extracción</label>
              </div>
              
            </div>
          </div>
          {isAlignmentByExtraction?
            <div className="col-md-12 col-xs-12">
              <div className="row">
                <div className="col-md-12">
                  <img src={orthogram} className="img-responsive"></img>
                </div>
                <div className="col-md-6 col-md-offset-3 form-group text-center">
                  <div className="vertical-separator-8px"></div>
                  <label>
                    Número de las piezas a extraer.
                  </label>
                  <input 
                    placeholder="1,2,3,..." 
                    className="form-control"
                    type="text"
                    onChange={(evt) => this.setState({piecesToExtract: evt.target.value})}
                    value={piecesToExtract}
                  />
                </div>
              </div>
            </div>
            :
            null
          }
          {alignmentByExtractionError.length > 0?
            <div className="col-md-12 text-center">
              <div className="error">{alignmentByExtractionError}</div>
            </div>
            :
            null
          }
        </div>

        <div className="vertical-separator-16px"></div> 

        <div className="row">
          <div className="col-md-10">
            <label>¿Quieres que el paciente emplee aditamentos?</label>
          </div>
          <div className="col-md-2 text-right">
            <Switch
              className="react-switch"
              checked={useAttachments}
              onChange={()=> {
                this.setState({useAttachments:!useAttachments})
                if(!useAttachments === false){
                  this.setState({attachmentsRestrictions:""});
                }
              }}
              onColor="#ABD1F9"
              offColor="#F0F0F0"
            />
          </div>
          {useAttachments?
            <div className="col-md-12">
              <textarea 
                className="form-control" 
                placeholder="Restricciones en los aditamentos"
                value={attachmentsRestrictions}
                onChange={(evt)=> this.setState({attachmentsRestrictions:evt.target.value})}
                ></textarea>
            </div>
            :
            null
          }
          
        </div>

        <div className="vertical-separator-24px"></div> 

        <div className="row">
          <div className="col-md-10">
            <label>Consideraciones adicionales para el tratamiento</label>
          </div>
          <div className="col-md-12">
            <textarea 
              className="form-control" 
              placeholder=""
              value={additionalConsiderations}
              onChange={(evt) => this.setState({additionalConsiderations: evt.target.value})}
            ></textarea>
          </div>
        </div>

        <div className="vertical-separator-32px"></div> 

        <div className="row justify-content-center">
          <div className="col-md-4 col-md-offset-4">
            {errorOnForm}
            <button
              className="button-outlined"
              onClick={this.onSave}
              >
              Guardar
            </button>
          </div>
          <div className="col-md-1">
            <div className="vertical-separator-8px"></div> 
            {loading}
          </div>
        </div>

        <div className="vertical-separator-32px"></div> 
      </div>
  );
  }
}

export default PlanningPreference;


// WEBPACK FOOTER //
// ./src/views/Forms/Patient/PlanningPreference.js